import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import * as Common from '_common';
import { useWidgetRegister } from '_frameRegister';
import * as React from 'react';
import { WidgetPlacementManager } from './WidgetPlacementManager';
export function StateFrames() {
    const frameRegister = Common.useFrameRegister();
    const spaContext = Common.useSpaContext();
    React.useEffect(() => {
        if (frameRegister && spaContext) {
            const processes = spaContext.process ?? {};
            for (const process of Object.keys(processes)) {
                const processInfo = processes[process];
                const existingFrame = frameRegister.frame(process);
                if (processInfo && processInfo !== 'null') {
                    if (!existingFrame) {
                        const frame = {
                            id: process,
                            title: processInfo.name || 'Process',
                            component: {
                                type: 'Process',
                                properties: { id: process },
                            },
                        };
                        frameRegister.register(frame);
                    }
                }
                else {
                    if (existingFrame) {
                        frameRegister.remove(process);
                    }
                }
            }
        }
    }, [frameRegister, spaContext]);
    return _jsx(_Fragment, {});
}
export const WidgetsContext = React.createContext([
    [],
    { getWidgets: () => [] },
]);
export function useWidgets() {
    const context = React.useContext(WidgetsContext);
    if (!context) {
        throw new Error('useWidgets must be used within a WidgetProvider');
    }
    return context;
}
export function WidgetProvider(props) {
    const widgetDefinitions = useWidgetRegister();
    const [widgets, setWidgets] = React.useState([]);
    const widgetPlacementManager = React.useMemo(() => new WidgetPlacementManager(widgets, setWidgets), [widgets]);
    React.useEffect(() => {
        loadWidgetPlacements(widgetDefinitions);
        setWidgets(widgetDefinitions);
    }, [widgetDefinitions]);
    return (_jsx(WidgetsContext.Provider, { value: [widgets, widgetPlacementManager], children: props.children }));
}
export function saveWidgetPlacements(widgets) {
    const placements = {};
    for (const widget of widgets) {
        if (widget.placement) {
            placements[widget.id] = widget.placement;
        }
    }
    localStorage.setItem('widgetPlacements', JSON.stringify(placements));
}
function loadWidgetPlacements(widgets) {
    const placementsStr = localStorage.getItem('widgetPlacements');
    if (!placementsStr) {
        return;
    }
    const placements = JSON.parse(placementsStr);
    for (const widget of widgets) {
        const widgetPlacements = placements[widget.id];
        if (widgetPlacements) {
            widget.placement = widgetPlacements;
        }
    }
}
